import React from 'react'

export const UserPlus = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" {...props}>
    <path d="M32 28C37.5228 28 42 32.4772 42 38V40C42 42.2092 40.2092 44 38 44H10C7.79086 44 6 42.2092 6 40V38C6 32.4772 10.4772 28 16 28H32ZM40 16C41.1046 16 42 16.8954 42 18V20H44C45.1046 20 46 20.8954 46 22C46 23.1046 45.1046 24 44 24H42V26C42 27.1046 41.1046 28 40 28C38.8954 28 38 27.1046 38 26V24H36C34.8954 24 34 23.1046 34 22C34 20.8954 34.8954 20 36 20H38V18C38 16.8954 38.8954 16 40 16ZM24 4C29.5228 4 34 8.47716 34 14C34 19.5228 29.5228 24 24 24C18.4772 24 14 19.5228 14 14C14 8.47716 18.4772 4 24 4Z" />
  </svg>
)
